module.exports = __webpack_public_path__ + "10fe2f41049ea19720dd119c276dc8df.MP3";